import { FormattedMessage } from 'react-intl';

import { IconTool, IconBrandAirbnb, IconBuildingSkyscraper, IconHomeDollar, IconDiscount, IconEye, IconCalendarEvent, IconUser } from '@tabler/icons';


const administration = {
    id: 'rooms',
    title: <FormattedMessage id="rooms-management" />,
    type: 'group',
    icon: IconTool,
    roles: ['ROLE_ADMIN', 'ROLE_AGENT'],
    children: [
        {
            id: 'rooms',
            title: <FormattedMessage id="rooms-management" />,
            type: 'item',
            url: '/app/rooms',
            roles: ['ROLE_ADMIN', 'ROLE_AGENT'],
            icon: IconBuildingSkyscraper,
        },
        {
            id: 'listings',
            title: <FormattedMessage id="listings" />,
            type: 'item',
            url: '/app/listings',
            roles: ['ROLE_ADMIN', 'ROLE_AGENT'],
            icon: IconBrandAirbnb,
        },
        {
            id: 'airbnb-accounts',
            title: 'Airbnb Accounts',
            type: 'item',
            url: '/app/airbnb-accounts',
            roles: ['ROLE_ADMIN', 'ROLE_AGENT'],
            icon: IconUser,
        },
        {
            id: 'pricing',
            title: <FormattedMessage id="pricing" />,
            type: 'collapse',
            roles: ['ROLE_ADMIN', 'ROLE_AGENT'],
            icon: IconHomeDollar,
            children: [
                {
                    id: 'pricer',
                    title: <FormattedMessage id="pricer" />,
                    type: 'item',
                    icon: IconHomeDollar,
                    url: '/app/pricer',
                    roles: ['ROLE_ADMIN', 'ROLE_AGENT'],
                },
                {
                    id: 'degressives',
                    title: <FormattedMessage id="degressives" />,
                    type: 'item',
                    icon: IconDiscount,
                    url: '/app/pricer/degressives',
                    roles: ['ROLE_ADMIN', 'ROLE_AGENT'],
                },
                {
                    id: 'watchlist',
                    title: <FormattedMessage id="watchlist" />,
                    type: 'item',
                    icon: IconEye,
                    url: '/app/pricer/watchlist',
                    roles: ['ROLE_ADMIN', 'ROLE_AGENT'],
                },
                {
                    id: 'events',
                    title: <FormattedMessage id="events" />,
                    type: 'item',
                    icon: IconCalendarEvent,
                    url: '/app/pricer/events',
                    roles: ['ROLE_ADMIN', 'ROLE_AGENT'],
                }
            ]
        }
    ]
}

export default administration;